import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { WelcomeSection } from '../components/WelcomeSection';
import { FocusSection } from '../components/FocusSection';
import { TrustSection } from '../components/TrustSection';
import { ServicesSection } from '../components/ServicesSection';
import { OpeningHoursSection } from '../components/OpeningHoursSection';
import { SmileViewSection } from '../components/SmileViewSection';
import { TeamSection } from '../components/TeamSection';
import { BlogPreview } from '../components/BlogPreview';
import { AppointmentCTA } from '../components/AppointmentCTA';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-off-white flex flex-col" data-id="element-233">
      <Navigation data-id="element-234" />
      <main className="flex-grow" data-id="element-235">
        <HeroSection data-id="element-236" />
        <WelcomeSection data-id="element-237" />
        <FocusSection data-id="element-238" />
        <TrustSection data-id="element-239" />
        <ServicesSection data-id="element-240" />
        <OpeningHoursSection data-id="element-241" />
        <SmileViewSection data-id="element-242" />
        <TeamSection data-id="element-243" />
        <BlogPreview data-id="element-244" />
        <AppointmentCTA data-id="element-245" />
      </main>
      <Footer data-id="element-246" />
    </div>;
}